import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const removeEmergentBadge = () => {
  if (typeof document === "undefined") {
    return;
  }

  const selectors = [
    "#emergent-badge",
    "[id*='emergent-badge']",
    "[class*='emergent-badge']",
    "#anti-badge-mask",
    "a[href*='utm_source=emergent-badge']",
    "a[href*='app.emergent.sh']",
    "a[href*='emergentagent']",
    "a[aria-label*='Emergent' i]",
    "a[title*='Emergent' i]",
    "a[style*='position: fixed'][style*='bottom'][style*='right']",
  ];

  selectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      element.style.setProperty("display", "none", "important");
      element.style.setProperty("visibility", "hidden", "important");
      element.remove();
    });
  });
};

removeEmergentBadge();
setInterval(removeEmergentBadge, 500);

if (typeof MutationObserver !== "undefined") {
  const emergentObserver = new MutationObserver(() => {
    removeEmergentBadge();
  });
  emergentObserver.observe(document.documentElement, { childList: true, subtree: true });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
